/**
 * Os três números do faturamento de um projeto, sempre com os mesmos nomes em todas as telas:
 * - Total a faturar: a venda (com o NetSuite, o total dos pedidos de venda);
 * - Valor faturado: o que já foi faturado;
 * - Faturamento remanescente: o que falta faturar (total − faturado).
 * Em dólar também, quando a venda é em dólar (aí os três fecham a conta na moeda do pedido).
 */
export interface BillingInput {
  saleBrl: number | null; saleUsd: number | null; invoicedBrl: number | null; invoicedUsd: number | null;
  billingPending: 'sim' | 'nao' | 'a_confirmar' | null; billingPendingBrl: number | null;
  /** Fase do projeto (cancelado não tem o que faturar; finalizado só se marcado). */
  phase?: string | null;
}

/** A mesma regra da API (apps/api/src/projects/billing.ts). */
export function billingOf(f: BillingInput) {
  const totalBrl = f.saleBrl;
  const flagged = f.billingPending === 'sim' || f.billingPending === 'a_confirmar' || (f.billingPendingBrl ?? 0) > 0.5;
  const remainingBrl = f.phase === 'cancelado' || f.billingPending === 'nao' ? 0
    : totalBrl == null ? f.billingPendingBrl
      : !flagged && f.phase === 'finalizado' ? 0
        : Math.max(0, totalBrl - (f.invoicedBrl ?? 0));
  // Valor faturado que fecha a conta: total − remanescente (o registrado, quando diferente, vai na dica).
  const invoicedBrl = totalBrl != null && remainingBrl != null ? Math.max(0, totalBrl - remainingBrl) : f.invoicedBrl;
  const recordedBrl = f.invoicedBrl;
  const totalUsd = f.saleUsd;
  const share = totalBrl ? (invoicedBrl ?? 0) / totalBrl : 0;
  // Em dólar: o faturado em dólar, se veio (NetSuite) e fecha com o remanescente; senão, a mesma proporção dos reais.
  const invoicedUsd = totalUsd == null ? f.invoicedUsd
    : f.invoicedUsd != null && remainingBrl != null && totalBrl != null && Math.abs((totalBrl - remainingBrl) - (f.invoicedBrl ?? 0)) < 1 ? f.invoicedUsd
      : Math.round(totalUsd * share * 100) / 100;
  const remainingUsd = totalUsd == null ? null : Math.max(0, totalUsd - (invoicedUsd ?? 0));
  const billedPct = totalBrl ? Math.min(100, Math.max(0, share * 100)) : null;
  return { totalBrl, invoicedBrl, recordedBrl, remainingBrl, totalUsd, invoicedUsd, remainingUsd, billedPct, toConfirm: f.billingPending === 'a_confirmar' };
}
